(function() {
    'use strict';
    angular
        .module('quilinkApp')
        .controller('DashboardController', DashboardController);


    DashboardController.$inject = ['Principal', 'EquipeCommerciale', 'DashboardKibana', '$sce', '$http'];

    function DashboardController(Principal, EquipeCommerciale, DashboardKibana, $sce, $http) {
        var vm = this;
        vm.ec;
        vm.iframeUrl;

        Principal.identity().then(function(account) {
            EquipeCommerciale.getByEmail({email: account.email}, function(result) {
                vm.ec = result;

                if (vm.ec.dashboardUrl) {
                    vm.iframeUrl = $sce.trustAsResourceUrl(vm.ec.dashboardUrl);
                }
            });
        });
    }
})();
